import useAirPlusLmsLanguage from 'src/hooks/useAirPlusLmsLanguage';
import React from 'react';
import { gql, useQuery } from '@apollo/client';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { getStudentTestMetrics } from 'src/pages/AirPlus/LevelTest/studentTestMetrics';
import { formatLexileMeasure } from 'src/pages/AirPlus/LevelTest/lexileReportData';

export const CURRENT_AIR_LEVEL = gql`
  query airPlusSidebarCurrentLevel {
    getUserData {
      idx lexile_level
      user_levelup_tests { idx type stat lexile level test_date test_end_date }
    }
  }
`;

const Card = styled.section`
  margin: 24px 2px 0;
  padding: 16px;
  border: 1px solid #ccebf6;
  border-radius: 18px;
  background: #f0f9ff;
  font-family: 'Nunito', Arial, 'Pretendard Variable', sans-serif;
  small { display: block; color: #4a6380; font-size: 11px; font-weight: 800; }
  strong { display: block; margin: 4px 0; color: #0c1a2e; font-size: 15px; font-weight: 900; }
  a, button { color: #009fc4; font: inherit; font-size: 12.5px; font-weight: 900; }
  button { padding: 0; border: 0; background: none; cursor: pointer; }
  a:hover { color: #007e9f; }
  a:focus-visible, button:focus-visible { outline: 2px solid #0891b2; outline-offset: 3px; }
`;

export function getCurrentAirLevel(user) {
  const metrics = getStudentTestMetrics(user);
  // Zero is also the default on accounts that have never taken a test.
  if (!metrics.latest && (!metrics.current || metrics.current.score === 0)) return null;
  const savedLevel = Number(metrics.latest?.level);
  const level = metrics.current?.current?.level || (Number.isInteger(savedLevel) && savedLevel >= 1 && savedLevel <= 12 ? savedLevel : null);
  if (!level) return null;
  const measure = metrics.current ? formatLexileMeasure(metrics.current.score) : null;
  return { level, label: `Level ${level}${measure ? ` · ${measure}` : ''}` };
}

export default function CurrentLevelCard() {
  const { t: airT } = useAirPlusLmsLanguage();
  const { data, loading, error, refetch } = useQuery(CURRENT_AIR_LEVEL);
  const current = getCurrentAirLevel(data?.getUserData);
  return <Card aria-label={airT("My aiR Level")}>
    <small>{airT("My aiR Level")}</small>
    {loading && !data ? <strong>{airT("Loading…")}</strong> : error ? <><strong>{airT("Level unavailable")}</strong><button type="button" onClick={() => refetch()}>{airT("Try again")}</button></> : current ? <>
      <strong>{airT(current.label)}</strong>
      <Link to={`/air-plus/library?service=alist&level=${current.level}`}>{airT("See books at my level →")}</Link>
    </> : <><strong>{airT("Not measured yet")}</strong><Link to="/air-plus/level-test">{airT("Take Level Test →")}</Link></>}
  </Card>;
}
